import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';
import * as Yup from 'yup';
import { Button, Col, Row } from 'react-bootstrap';
import { format, parseISO } from 'date-fns';
import api from '../../../../../services/api';
import SelectSync, { IOption } from '../../../../../components/SelectSync';
import Input from '../../../../../components/Input';
import TextArea from '../../../../../components/TextArea';
import { ICadastroCobranca } from '../..';
import { useToast } from '../../../../../hooks/toast';
import getValidationErrors from '../../../../../utils/getValidationErrors';
import getResponseErrors from '../../../../../utils/getResponseErrors';
import Modal from '../../../../../components/Modal';
import Parcelas from './parcelas';
import { IParcelasCobranca } from '..';
import InputMoney from '../../../../../components/InputMoney';
import Loading from '../../../../../components/Loading';

// import { Container } from './styles';

interface ICobrancaFormDados {
  CobDataAviso: Date;
  CobMotCodigo: number;
  CobTipo: string;
  CobObservacao: string;
  selecionados?: string;
  CobDataVenc?: Date;
}

export interface IRetornoCobranca extends ICobrancaFormDados {
  CobCodigo: number;
  CobCprCodigo: string;
  CobPlaCodigo: number;
  CobUsuCodigo: number;
  CobData: Date;
  CobDataFormatada?: string;
  CobDataAvisoFormatada?: string;
  CobUsuNome: string;
  CobValor: number;
  CobLink: string;
  CobCprCodigoBoleto: number;
  parcela?: IParcelasCobranca;
}

interface FormProps {
  dadosCobranca: ICadastroCobranca;
  optionsMotivo: IOption[];
  handleFechar(plaCodigo: number | undefined): void;
  parcelas: IParcelasCobranca[];
  atualizaDadosCobranca(plaCodigo: number): Promise<void>;
  temBoleto: boolean;
  podeGerarBoleto: boolean;
  motivo?: string;
}
const Formulario: React.FC<FormProps> = ({
  dadosCobranca,
  optionsMotivo,
  parcelas,
  handleFechar,
  atualizaDadosCobranca,
  temBoleto,
  podeGerarBoleto,
  motivo,
}) => {
  const { addToast } = useToast();
  const formRefCadastro = useRef<FormHandles>(null);

  const [loading, setLoading] = useState(false);
  const [showBoletoNegociacao, setShowBoletoNegociacao] = useState<
    string | undefined
  >(undefined);
  const handleOnChange = useCallback(
    ({ value }) => {
      formRefCadastro.current?.setFieldValue('CobObservacao', '');
      if (value) {
        if (value === '20')
          formRefCadastro.current?.setFieldValue(
            'CobObservacao',
            'AVISO DE ATRASO',
          );
        if (value === '22')
          formRefCadastro.current?.setFieldValue(
            'CobObservacao',
            'LEMBRETE DE VENCIMENTO',
          );
        if (
          (value === '400' || value === '401') &&
          motivo !== '400' &&
          motivo !== '401'
        ) {
          if (!temBoleto && podeGerarBoleto) setShowBoletoNegociacao(value);

          if (!podeGerarBoleto) {
            addToast({
              type: 'error',
              title: 'Adicionar boleto de negociação',
              description:
                'Não é possivel adicionar nova negociação, pois o responsável ou titular não possui CPF cadastrado.',
            });
          }
        }
        if (temBoleto) {
          addToast({
            type: 'error',
            title: 'Adicionar boleto de negociação',
            description:
              'Não é possivel adicionar nova negociação, se já existe uma negociação em aberto.',
          });
        }
      }
    },
    [motivo, temBoleto, addToast, podeGerarBoleto],
  );

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  const handleOnChangeVazio = useCallback(() => {}, []);

  const handleSubmit = useCallback(
    async (dados: ICobrancaFormDados) => {
      setLoading(true);
      try {
        if (!dadosCobranca)
          addToast({ type: 'error', title: 'Codigo do plano não encontrado' });

        if (
          (dados.CobMotCodigo.toString() === '400' ||
            dados.CobMotCodigo.toString() === '401') &&
          motivo !== '400' &&
          motivo !== '401' &&
          temBoleto
        ) {
          addToast({
            type: 'error',
            title:
              'Não é possivel adicionar nova negociação, se já existe uma negociação em aberto.',
            timeAlive: 10000,
          });
          return;
        }

        if (
          (dados.CobMotCodigo.toString() === '400' ||
            dados.CobMotCodigo.toString() === '401') &&
          !podeGerarBoleto
        ) {
          addToast({
            type: 'error',
            title: 'Adicionar boleto de negociação',
            description:
              'Não é possivel adicionar nova negociação, pois o responsável ou titular não possui CPF cadastrado.',
          });
          return;
        }

        formRefCadastro.current?.setErrors({});
        const schema = Yup.object().shape({
          CobDataAviso: Yup.date().required(),
          CobMotCodigo: Yup.number()
            .typeError('selecione um motivo')
            .required('selecione um motivo'),
          CobTipo: Yup.string().required('selecione um tipo'),
          CobObservacao: Yup.string().required('Adicione uma observação'),
          CobDataVenc: Yup.date()
            .typeError('Digite uma data válida')
            .when('CobMotCodigo', {
              is: 400,
              then: Yup.date()
                .typeError('Digite uma data válida')
                .required('Data de Vencimento é obrigatório'),
            })
            .when('CobMotCodigo', {
              is: 401,
              then: Yup.date()
                .typeError('Digite uma data válida')
                .required('Data de Vencimento é obrigatório'),
            }),
          CobValor: Yup.number()
            .typeError('Digite o valor')
            .when('CobMotCodigo', {
              is: 400,
              then: Yup.number()
                .typeError('Digite o valor')
                .required('Valor é obrigatório')
                .test(
                  'valor',
                  'Valor mínimo 5 reais',
                  value => value !== undefined && value >= 5,
                ),
            })
            .when('CobMotCodigo', {
              is: 401,
              then: Yup.number()
                .typeError('Digite o valor')
                .required('Valor é obrigatório')
                .test(
                  'valor',
                  'Valor mínimo 5 reais',
                  value => value !== undefined && value >= 5,
                ),
            }),
        });

        await schema.validate(dados, {
          abortEarly: false,
        });

        const cobranca = {
          ...dados,
          CobObservacao: dados.CobObservacao.toUpperCase(),
          CobDataAviso: parseISO(`${dados.CobDataAviso.toString()} 12:00:00`),
          ...(dados.CobDataVenc
            ? {
                CobDataVenc: parseISO(
                  `${dados.CobDataVenc.toString()} 12:00:00`,
                ),
              }
            : {}),
          CobPlaCodigo: dadosCobranca.plaCodigo,
          CobCprCodigo:
            dados.CobMotCodigo.toString() === '400' ||
            dados.CobMotCodigo.toString() === '401'
              ? dados.selecionados
              : dadosCobranca.codigo,
          selecionados: undefined,
        };

        const novaCobranca = await api.post<IRetornoCobranca>(
          '/cobranca',
          cobranca,
        );

        addToast({ title: 'Cobrança salva', type: 'success' });

        if (
          dados.CobMotCodigo.toString() === '400' ||
          dados.CobMotCodigo.toString() === '401'
        )
          atualizaDadosCobranca(novaCobranca.data.CobPlaCodigo);
        handleFechar(novaCobranca.data.CobPlaCodigo);
      } catch (error) {
        if (error instanceof Yup.ValidationError) {
          const errors = getValidationErrors(error);

          formRefCadastro.current?.setErrors(errors);
          return;
        }
        const mensagemErro = getResponseErrors(error);
        // const statusErro = error?.response?.status;
        // if (statusErro === 403) {
        //   setExibePermissaoAdmin(true);
        //   setMensagemPermissaoAdmin(mensagemErro);
        // }
        addToast({
          type: 'error',
          title: 'Erro ao salvar cobrança',
          description: mensagemErro,
        });
      } finally {
        setLoading(false);
      }
    },
    [dadosCobranca, addToast, handleFechar, atualizaDadosCobranca, motivo],
  );

  useEffect(() => {
    if (motivo) {
      formRefCadastro.current?.setFieldValue('CobMotCodigo', motivo);
    }
  }, [motivo]);

  return (
    <>
      {loading && <Loading backgroundBlack={false} />}
      {(showBoletoNegociacao === '400' || showBoletoNegociacao === '401') && (
        <Modal
          show={
            showBoletoNegociacao === '400' || showBoletoNegociacao === '401'
          }
          titulo="Gerar Boleto Negociação"
          handleFecharModal={() => setShowBoletoNegociacao(undefined)}
          large
        >
          <Formulario
            handleFechar={() => setShowBoletoNegociacao(undefined)}
            dadosCobranca={dadosCobranca}
            optionsMotivo={optionsMotivo}
            motivo={showBoletoNegociacao}
            parcelas={parcelas}
            atualizaDadosCobranca={atualizaDadosCobranca}
            temBoleto={false}
            podeGerarBoleto
          />
        </Modal>
      )}

      <Form
        ref={formRefCadastro}
        initialData={{
          CobTipo: 'WhatsApp',
          CobDataAviso: format(new Date(), 'yyy-MM-dd'),
          CobMotCodigo: showBoletoNegociacao?.toString(),
        }}
        onSubmit={handleSubmit}
      >
        <Row>
          <Col md="6" lg="6" className="form-group pr-2">
            <SelectSync
              name="CobMotCodigo"
              label="Motivo"
              placeholder="Selecione"
              isClearable={false}
              handleSelectChange={handleOnChange}
              options={optionsMotivo || [{ label: '', value: '' }]}
              isDisabled={motivo === '400' || motivo === '401'}
            />
          </Col>
          <Col md="3" lg="3" className="form-group pr-2">
            <SelectSync
              name="CobTipo"
              label="Tipo"
              placeholder="Selecione"
              isClearable={false}
              handleSelectChange={handleOnChangeVazio}
              options={[
                { label: 'Telefone', value: 'Telefone' },
                { label: 'E-mail', value: 'E-mail' },
                { label: 'WhatsApp', value: 'WhatsApp' },
              ]}
            />
          </Col>
          <Col md={3} lg={3}>
            <Input name="CobDataAviso" label="Data" type="date" required />
          </Col>
        </Row>
        {(motivo === '400' || motivo === '401') && (
          <>
            <Parcelas name="selecionados" parcelas={parcelas} />

            <Row>
              <Col md={3} lg={3} className="form-group pr-2">
                <InputMoney
                  name="CobValor"
                  label="Valor"
                  autoComplete="nope"
                  placeholder="Valor"
                />
              </Col>
              <Col md={3} lg={3}>
                <Input name="CobDataVenc" label="Data Venc." type="date" />
              </Col>
            </Row>
          </>
        )}
        <Row>
          <Col md="9" lg="9" className="form-group pr-2">
            <TextArea name="CobObservacao" label="Observação" rows={3} />
          </Col>
          <Col md={3} lg={3} className="form-group pr-2">
            <Button type="submit" className="mt-5">
              Salvar
            </Button>
          </Col>
        </Row>
      </Form>
    </>
  );
};

export default Formulario;
